



export default [
  {
    path: '/historial_terapia/:id',
    name: 'historial_terapia',
    component: () => import('@/views/terapia/Historialterapia.vue'),
    meta: {
      pageTitle: 'Retirar receta',
      breadcrumb: [
        {
          text: 'Terapias Programadas',
          to: '/consultar_terapia_programada'
        },
        {
          text: 'Historial Terapia',
          active: true,
        },
        
      ],
      requiresAuth: true,
      requiredPermission: 'historial_terapia', // Permiso requerido
    },
  },


  {
    path: '/consultar_terapia_programada',
    name: 'consultar_terapia_programada',
    component: () => import('@/views/terapia/pages/ConsultarTerapiaProgramada.vue'),
    meta: {
      pageTitle: 'Consultar Terapia',
      breadcrumb: [
        {
          text: 'Terapias Programadas',
          active: true,
        },
        
      ],
      requiresAuth: true,
      requiredPermission: 'consultar_terapias_programadas', // Permiso requerido
    },
  },


  {
    path: '/consultar_cartera_terapia',
    name: 'consultar_cartera_terapia',
    component: () => import('@/views/terapia/Carteraterapia.vue'),
    meta: {
      pageTitle: 'Consultar Terapias',
      breadcrumb: [
        {
          text: 'Terapias',
        },
      ],
      requiresAuth: true,
      requiredPermission: 'consultar_cartera_examen', // Permiso requerido
      // accion1 removido para usar modal de creación en la misma página
      pdf: false,
      excel: false
    },
  },

  {
    path: '/crear_terapia',
    name: 'crear_terapia',
    component: () => import('@/views/terapia/CrearEditarTerapia.vue'),
    meta: {
      pageTitle: 'Crear Terapia',
      breadcrumb: [
        {
          text: 'Servicios Terapia',
          to: '/consultar_cartera_terapia',
        },
        {
          text: 'Crear Terapia',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'crear_terapia', // Permiso requerido
    },
  },

  {
    path: '/ver_terapia/:token',
    name: 'ver_terapia',
    component: () => import('@/views/terapia/Verterapia.vue'),
    meta: {
      pageTitle: 'Ver Terapia',
      breadcrumb: [
        {
          text: 'Terapia',
          to: '/consultar_cartera_terapia',
        },
        {
          text: 'Ver Terapia',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'ver_terapia', // Permiso requerido
    },
  },

  {
    path: '/editar_terapia/:token',
    name: 'editar_terapia',
    component: () => import('@/views/terapia/Editarterapia.vue'),
    meta: {
      pageTitle: 'Editar Terapia',
      breadcrumb: [
        {
          text: 'Terapia',
          to: '/consultar_cartera_terapia',
        },
        {
          text: 'Editar Terapia',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'editar_terapia', // Permiso requerido
    },
  },
]
